module.exports = __webpack_public_path__ + "img/footer-768x115.c0026e21.png";